import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "instalros_lang";

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved && translations[saved]) return saved;
    }
    return "es";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch {
      /* ignore */
    }
  }, [lang]);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let cursor = translations[lang] || translations.es;
      for (const k of keys) {
        if (cursor == null) return path;
        cursor = cursor[k];
      }
      if (cursor == null) {
        // fallback to es
        let fb = translations.es;
        for (const k of keys) {
          if (fb == null) return path;
          fb = fb[k];
        }
        return fb ?? path;
      }
      return cursor;
    },
    [lang],
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
